// BrandMark — muestra el logo de la marca activa, o el wordmark Optimus si no hay logo.
// Replica el comportamiento del prototipo (brand-mark.jsx) en componentes Ant Design-friendly.

import React from 'react';
import { useBrand } from '../../context/BrandContext';

export function OptimusWordmark({ color = '#15306b', accent = '#d97347', size = 32 }) {
    return (
        <div className="optimus-wordmark" style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            fontFamily: 'Inter, system-ui, sans-serif',
            letterSpacing: '-0.02em',
        }}>
            <div className="optimus-wordmark-icon" style={{
                width: size, height: size, borderRadius: 6,
                background: color, position: 'relative',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
            }}>
                <div style={{
                    width: size * 0.45, height: size * 0.45,
                    borderRadius: '50%',
                    border: `${Math.max(2, size * 0.08)}px solid white`,
                    borderTopColor: 'transparent',
                    borderRightColor: accent,
                    transform: 'rotate(-30deg)',
                }} />
            </div>
            <span className="optimus-wordmark-text" style={{
                fontSize: size * 0.55, fontWeight: 800, color, lineHeight: 1,
            }}>OPTIMUS</span>
        </div>
    );
}

export default function BrandMark({ size = 32, dark = false, palette: paletteOverride = null }) {
    const { brand } = useBrand();
    const palette = paletteOverride || brand;

    if (palette.logo) {
        return (
            <img
                className="brand-logo-img"
                src={palette.logo}
                alt={palette.name}
                style={{ height: size, width: 'auto', objectFit: 'contain', maxWidth: '100%' }}
            />
        );
    }
    return (
        <OptimusWordmark
            color={dark ? '#fff' : palette.primary}
            accent={palette.accent}
            size={size}
        />
    );
}
